// extracted by mini-css-extract-plugin
export default {"videostack":"video_videostack__Yd6wv"};